import { render, staticRenderFns } from "./copier.vue?vue&type=template&id=225233de&"
import script from "./copier.vue?vue&type=script&lang=js&"
export * from "./copier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports